import { render, staticRenderFns } from "./InitMenu.vue?vue&type=template&id=d8734e60&scoped=true"
import script from "./InitMenu.vue?vue&type=script&lang=js"
export * from "./InitMenu.vue?vue&type=script&lang=js"
import style0 from "./InitMenu.vue?vue&type=style&index=0&id=d8734e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8734e60",
  null
  
)

export default component.exports